@if (load()) {
  <div class="fixed inset-0 z-90000! flex flex-col items-center justify-center bg-black/30 backdrop-blur-sm">
    <ng-lottie width="220px" height="220px" [options]="lottieOptions"></ng-lottie>

    @if (showProgress()) {
      <div class="w-60 max-w-[80vw] flex flex-col gap-1 -mt-4">
        <mat-progress-bar mode="determinate" class="custom-progress" [value]="progress()"></mat-progress-bar>
        <span class="text-right text-xs font-medium text-white">
          {{ progress() }}%
        </span>
      </div>
    }
  </div>
}
